const enumValue = value => value?.databaseValue ?? value;

export function getOrderMergeRules(orders) {
  const riskOrders = [];
  const blockedOrders = [];
  const unavailableOrders = [];
  for (const order of orders) {
    if (['SENT', 'CANCELLED', 'RETURNED'].includes(enumValue(order.orderStatus)))
      unavailableOrders.push(order);
    const payment = enumValue(order.paymentType);
    const prepaidProm = ['PROM_PAYMENT', 'PROM_PAY_BY_PARTS'].includes(payment);
    if (prepaidProm) riskOrders.push(order);
    if (Number(order.promOrderId) > 0 && payment !== 'CASH_ON_DELIVERY' && !prepaidProm)
      blockedOrders.push(order);
  }
  return { riskOrders, blockedOrders, unavailableOrders };
}
